var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-4"},[_c('v-col',{staticClass:"error-banner",attrs:{"cols":"10","offset":"1"}},[_c('span',{staticClass:"red--text"},[_vm._v("Une erreur est survenue.")]),_c('br'),_c('router-link',{attrs:{"to":"/dossier"}},[_vm._v("Retour à la liste des dossiers")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }